import {makeAutoObservable, reaction} from 'mobx';
import {useStore} from "./index";
import {updateLocalState} from '../editor/utils/localState';

const updateTheme = (theme, store) => {
    if (theme) {
        const {classList} = document.documentElement;
        let isDark = false;

        if (theme === 'dark' || (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            classList.add('dark');
            isDark = true;
        } else {
            classList.remove('dark');
        }

        if (store.appEditorStore.updateAppShell) {
            const metaTag = document.head.querySelector('meta[name="theme-color"]');
            if (metaTag) metaTag.content = isDark ? '#18181b' : '#ffffff';
        }
    }
};

export class LocalSettingsStore {
    store;
    theme = 'dark';
    lastProjectId = '';
    debug = false;

    constructor(store, initialState) {
        this.store = store;

        initialState && Object.keys(initialState).forEach((key) => {
            const keyId = key;
            const value = initialState[keyId];
            if (value !== undefined) {
                // @ts-ignore Have to prevent readonly properties
                this[keyId] = value;
            }
        })

        makeAutoObservable(this, {}, {autoBind: true});
        updateTheme(this.theme, store);
    }

    get isDarkTheme() {
        const {theme} = this;
        return theme === 'dark' || (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    }

    setTheme(value) {
        this.theme = value;
    }
}

export const subscribeToLocalSettingsStore = (localSettingsStore) => {
    reaction(() => localSettingsStore.theme, (theme) => {
        updateTheme(theme, localSettingsStore.store);
        updateLocalState({theme});
    });
};

export const useLocalSettingsStore = () => {
    return useStore().localSettingsStore;
}